<template>
  <div class="document">
    <div class="document-contents">
      <section class="document-contents-selection" v-on:scroll="handleScroll()">
        <div v-for="(data, index) in items" :key="index">
          <ul
            class="product-img-wrap"
            @click="linkToDocument(data.document_url)"
          >
            <div class="image-area">
              <img :src="data.image" />
              <div>
                <p class="project-title">{{ data.title }}</p>
                <div class="state">
                  <span>{{ displayStatus(data.aplication_state) }}</span>
                </div>
              </div>
            </div>
          </ul>
        </div>
        <div
          :style="hiddenLoading()"
          v-show="loading"
          :class="[items && items.length > 0 ? 'loading' : 'first-loading']"
        >
          <img src="../assets/loading.gif" />
        </div>
      </section>
    </div>
    <div v-if="!loading && !items?.length" class="no-data">
      <img :src="NO_DATA.get(5).img" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { projects } from "../types/apiResponse";
import { APPLICATION_STATE_NAME, BASEURL } from "../consts/common";
import { ProjectStore } from "../store/ProjectStore";
import { ref, onMounted, nextTick } from "vue";
import { CommonStore } from "../store/CommonStore";
import { NO_DATA } from "../consts/common";
const projectStore = ProjectStore();
const commonStore = CommonStore();
const items = ref<projects[]>();
const loading = ref(true);
const infiteScroll = ref(false);
onMounted(async () => {
  if (!projectStore.documentList.length) {
    await projectStore.getDocumentProjects();
  } else {
    nextTick(() => getScrollHeight());
  }
  items.value = projectStore.documentList;
  loading.value = false;
});
const handleScroll = async () => {
  if (loading.value) return;
  const container = document.getElementsByClassName(
    "document-contents-selection"
  )[0] as HTMLElement;
  setScrollHeight();
  if (projectStore.documentAllCalled) return;
  if (!container || !container.scrollHeight) return
  if (
    container.scrollHeight - (container.clientHeight + container.scrollTop) >
    120
  )
    return;

  loading.value = true;
  const pageNum = projectStore.documentPageNum + 1;
  projectStore.setDocumentPageNum(pageNum);
  await projectStore.getDocumentProjects();
  infiteScroll.value = true;
  infiteScroll.value = false;
  items.value = projectStore.documentList;
  loading.value = false;
};
const setScrollHeight = () => {
  const item = document.getElementsByClassName(
    "document-contents-selection"
  )[0] as HTMLElement;
  commonStore.setDocumentScrollHeight(item.scrollTop);
};

const hiddenLoading = () => {
  if (!loading.value) {
    return "visibility: hidden;";
  } else {
    return "visibility: visible;";
  }
};

const getScrollHeight = () => {
  const item = document.getElementsByClassName(
    "document-contents-selection"
  )[0] as HTMLElement;
  item.scrollTo({
    top: commonStore.getDocumentScrollHeight,
    behavior: "auto",
  });
};

const linkToDocument = (url: string) => {
  window.open(BASEURL + url);
};
const displayStatus = (state: number) => {
  return APPLICATION_STATE_NAME.find((v) => v.state == state)?.name;
};
</script>

<style scoped lang="scss">
@import "../assets/style/_variables.scss";
@import "../assets/style/mixin.scss";

.document {
  overflow-y: auto;
  height: 100%;
}
.document-contents {
  width: 100%;
  height: calc(100% - 10px);
  display: flex;
}
.document-contents-selection {
  overflow-y: auto;
  // height: 680px;
  box-sizing: border-box;
  padding: 10px;
  width: 100%;
  transition: all 0.8s ease;
}
.document-contents-selection::-webkit-scrollbar {
  display: none;
}
.product-img-wrap {
  list-style: none;
  padding-left: 0;
  width: 100%;
  background: #fafafa;
  border: 1px solid #d9d9d9;
  height: 130px;
  border-radius: 10px;
}
.image-area {
  display: flex;
  width: 100%;
  height: 100%;
  > img {
    min-width: 110px;
    min-height: 110px;
    object-fit: cover;
    margin: 10px 0 9px 9.5px;
    border-radius: 10px;
  }
  .project-title {
    margin: 10px 16px 0 14px;
    overflow-y: hidden;
    font-weight: 300;
    height: 43px;
    line-height: 21px;
    font-size: $FONT_SIZE_M;
    @include line-clamp(2);
    word-break: break-all;
  }
  .state {
    margin-left: 18.5px;
    margin-top: 10px;
    display: inline-block;
    height: 18px;
    background: rgba(0, 116, 255, 0.07);
    border-radius: 2px;
    font-style: normal;
    font-weight: 300;
    font-size: $FONT_SIZE_S;
    line-height: 18px;

    // color: #ed293e;
    span {
      color: $OMOT_COLOR;
    }
  }
}
.button-area {
  @include footer-button(315px);
}

.loading {
  // display: flex;
  // position: relative;
  // justify-content: center;
  // top: 50%;
  top: -30px;
  position: relative;
  text-align: center;

  img {
    width: 10%;
    height: 10%;
  }
}
.first-loading {
  display: flex;
  width: 96%;
  max-width: 460px;
  position: fixed;
  justify-content: center;
  top: 40%;
  img {
    width: 10%;
    height: 10%;
  }
}
</style>
